module.exports = __webpack_public_path__ + "static/media/ceo.b1292382.png";